/**
 * Single source of truth for the in-product support contact address.
 *
 * Exported as a constant rather than inlined so other surfaces (empty
 * states, error pages, future help links) can reference the same address
 * without duplicating the string.
 */
export const SUPPORT_EMAIL = 'hello@loristry.com';
